module.exports = __webpack_public_path__ + "img/ridgeline22.3c455b46.png";